import { ChannelPersistedConfigInput } from '@playbook-technologies/common-schemas/lib/catalog';

export const loadChannelConfig = <T extends ChannelPersistedConfigInput>(
  config: T,
) => config;

export const saveChannelConfig = <T extends ChannelPersistedConfigInput>(
  config: T,
) => ({
  ...config,
  sections: config.sections.map((section) =>
    section.type === 'Logos'
      ? { ...section, logos: section.logos?.filter((logo) => logo.url) }
      : section,
  ),
});
